import {
  AfterViewInit,
  Component,
  OnInit,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { SignupService } from '../../../services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { WatcherService } from 'src/app/services/watcher.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { allCountriesList } from 'src/app/shared/countryList';
import { MatDialog } from '@angular/material/dialog';
import { RefundShipmentDialogComponent } from './refund-shipment-dialog/refund-shipment-dialog.component';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';

declare var $;
declare var Stripe: any;
@Component({
  selector: 'app-b2b-api-user',
  templateUrl: './b2b-api-user.component.html',
  styleUrls: ['./b2b-api-user.component.css'],
})
export class B2BApiUserComponent implements OnInit, AfterViewInit, OnDestroy {
  token;
  userID;
  lang;
  memberDetails;
  countriesList: any[] = allCountriesList;
  currentPage = 1;
  pageSize = 20;
  isLoading = false;
  hasMoreData = true;
  totalShipments = 0;
  xApiToken: string;

  private filterSubject = new Subject<void>();
  private readonly DEBOUNCE_TIME = 300;

  private currentEnvironment: string = 'production';

  constructor(
    private signUpService: SignupService,
    private toastr: ToastrService,
    private watcherService: WatcherService,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private clipboard: Clipboard
  ) {
    this.signUpService.getAllCountries().subscribe((list) => {
      this.countriesList = list['data'];
    });
    this.store.select('auth').subscribe((state) => {
      this.token = state.token;
      this.userID = state.user?.id;
    });
    this.signUpService
      .getUserByUserID(this.userID, this.token)
      .subscribe((data) => {
        this.memberDetails = data['data'];
      });
    this.signUpService.getB2BUserTestAPIKeys(this.token).subscribe({
      next: (data) => {
        this.xApiToken = data['api_key'];
      },
      error: (error) => {
        this.toastr.error('Contact with Shippn Support for Creating a Test Account', 'Error');
      },
    })
    this.filterSubject
      .pipe(debounceTime(this.DEBOUNCE_TIME), distinctUntilChanged())
      .subscribe(() => {
        this.resetAndReload();
      });
  }

  shipmentsListData;
  ngOnInit(): void {
    window.scrollTo(0, 0);

    this.route.queryParams.subscribe((params) => {

      if (params['search'] == '') {
        delete params['search'];
      }
      this.filters = {
        company_id: params['company_id'] || 'all',
        status: params['status'] || 'all',
        pickup_status: params['pickup_status'] || 'all',
        date_range: params['date_range'] || 'none',
        custom_date_range: {
          start: params['date_start'] ? parseInt(params['date_start']) : 0,
          end: params['date_end'] ? parseInt(params['date_end']) : 0,
        },
        searchQuery: params['search'] || '',
        environment: params['environment'] || 'Environment',
      };
      this.currentPage = parseInt(params['page']) || 1;
      this.pageSize = parseInt(params['page_size']) || 20;

      if (this.userID && this.token) {
        this.updateQueryParams();
        this.loadMoreShipments(true);
      }
    });

    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
    const contentWrapper = document.querySelector(
      '.shippn-b2b-pages-content-content-wrapper'
    );
    if (contentWrapper) {
      contentWrapper.addEventListener('scroll', (event) =>
        this.onScroll(event)
      );
    }
  }

  ngOnDestroy(): void {
    const contentWrapper = document.querySelector(
      '.shippn-b2b-pages-content-content-wrapper'
    );
    if (contentWrapper) {
      contentWrapper.removeEventListener('scroll', (event) =>
        this.onScroll(event)
      );
    }

    this.filterSubject.complete();
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any): void {
    const element = event.target;
    if (
      this.isNearBottomOfDiv(element) &&
      !this.isLoading &&
      this.hasMoreData
    ) {
      this.loadMoreShipments();
    }
  }

  isNearBottomOfDiv(element: any): boolean {
    const threshold = 100;
    return (
      element.scrollHeight - (element.scrollTop + element.clientHeight) <=
      threshold
    );
  }

  loadMoreShipments(isNewFilter: boolean = false): void {
    if (this.isLoading || (!isNewFilter && !this.hasMoreData)) return;

    this.isLoading = true;
    const payload = this.prepareApiPayload();
    this.updateQueryParams();
    if (this.currentEnvironment !== (payload.environment || 'production')) {
      this.currentPage = 1;
      this.shipmentsListData = [];
      this.hasMoreData = true;
      this.currentEnvironment = payload.environment || 'production';
      isNewFilter = true;
    }

    if (payload.environment === 'Environment' || payload.environment === 'production' || !payload.environment) {
      this.signUpService
        .getB2BShipmentsListByUser(this.token, this.userID, payload)
        .subscribe({
          next: (data) => {
            this.totalShipments = data['result']['count'];

            const tempData = data['data'].filter(
              (element) =>
                element.status >= 7 || element.status == 0 || element.status == 98
            );

            this.hasMoreData =
              this.currentPage * this.pageSize < this.totalShipments;


            tempData.forEach((element) => {
              try {
                element.shipment.company_name = this.getCourierName(
                  element.shipment.company_id
                );
                element.shipment.service_type_name = this.getServiceTypeName(
                  element.shipment.service_type
                );
                element.status_name = this.getShipmentStatusName(element.status);
                element.destination_country_name = this.getCountryName(
                  element.shipment.zone
                );
                element.show_details = false;
              } catch (error) {
                this.toastr.error(
                  'An error occured while building table',
                  'Error'
                );
              }
            });

            if (isNewFilter || this.currentPage === 1) {
              this.shipmentsListData = tempData;
            } else {
              this.shipmentsListData = [...this.shipmentsListData, ...tempData];
            }

            this.currentPage++;
            this.isLoading = false;
          },
          error: (error) => {
            this.toastr.error(error.error.message);
            this.isLoading = false;
          },
        });
    } else if (payload.environment === 'test') {
      if (this.xApiToken) {
        this.signUpService
          .getB2BTestShipmentsListByUser(this.xApiToken, this.userID, payload)
          .subscribe({
            next: (data) => {
              this.totalShipments = data['pagination']['total_items'];

              const tempData = data['data'];

              this.hasMoreData = data['pagination']['has_next'];

              tempData.forEach((element) => {
                try {
                  element.shipment.company_name = this.getCourierName(
                    element.shipment.company_id
                  );
                  element.shipment.service_type_name = this.getServiceTypeName(
                    element.shipment.service_type
                  );
                  element.status_name = this.getShipmentStatusName(element.status);
                  element.destination_country_name = this.getCountryName(
                    element.shipment.zone
                  );
                  element.show_details = false;
                } catch (error) {
                  this.toastr.error(
                    'An error occured while building table',
                    'Error'
                  );
                }
              });

              if (isNewFilter || this.currentPage === 1) {
                this.shipmentsListData = tempData;
              } else {
                this.shipmentsListData = [...this.shipmentsListData, ...tempData];
              }

              this.currentPage++;
              this.isLoading = false;
            },
            error: (error) => {
              this.toastr.error(error.error.message);
              this.isLoading = false;
            },
          });
      } else {
        this.signUpService.getB2BUserTestAPIKeys(this.token).subscribe({
          next: (apiKeyResponse) => {

            this.xApiToken = apiKeyResponse['api_key'];
            this.signUpService
              .getB2BTestShipmentsListByUser(this.xApiToken, this.userID, payload)
              .subscribe({
                next: (data) => {
                  this.totalShipments = data['pagination']['total_items'];

                  const tempData = data['data'];

                  this.hasMoreData = data['pagination']['has_next'];

                  tempData.forEach((element) => {
                    try {
                      element.shipment.company_name = this.getCourierName(
                        element.shipment.company_id
                      );
                      element.shipment.service_type_name = this.getServiceTypeName(
                        element.shipment.service_type
                      );
                      element.status_name = this.getShipmentStatusName(element.status);
                      element.destination_country_name = this.getCountryName(
                        element.shipment.zone
                      );
                      element.show_details = false;
                    } catch (error) {
                      this.toastr.error(
                        'An error occured while building table',
                        'Error'
                      );
                    }
                  });

                  if (isNewFilter || this.currentPage === 1) {
                    this.shipmentsListData = tempData;
                  } else {
                    this.shipmentsListData = [...this.shipmentsListData, ...tempData];
                  }

                  this.currentPage++;
                  this.isLoading = false;
                },
                error: (error) => {
                  this.toastr.error(error.error.message);
                  this.isLoading = false;
                },
              });
          }
        })
      }
    }

  }

  ngAfterViewInit(): void { }
  getCourierName(company_id) {
    const courier = this.courierList.find(
      (element) => element.id == company_id
    );
    return courier ? courier.name : 'N/A';
  }

  getServiceTypeName(serviceType) {
    const service = this.serviceTypeList.find(
      (element) => element.id == serviceType
    );
    return service ? service.name : 'N/A';
  }

  getShipmentStatusName(status) {
    const shipmentStatus = this.b2bShipmentStatusList.find(
      (element) => element.id == status
    );
    return shipmentStatus ? shipmentStatus.name : 'N/A';
  }

  getCountryName(country_code) {
    if (country_code) {
      const country = this.countriesList.find(
        (element) => element.code == country_code
      );
      return country ? country.name : 'N/A';
    } else {
      return 'N/A';
    }
  }

  serviceTypeList = [
    { name: 'Express', id: 1 },
    { name: 'Economy', id: 2 },
    { name: 'Connect Plus', id: 3 },
    { name: 'Standard', id: 4 },
    { name: 'Regional Economy', id: 5 },
  ];
  courierList = [
    { name: 'TNT', id: 1 },
    { name: 'UPS', id: 2 },
    { name: 'DHL', id: 3 },
    { name: 'FedEx', id: 4 },
    { name: 'AusPost', id: 5 },
    { name: 'USPS', id: 6 },
    { name: 'Aramex', id: 7 },
    { name: 'LaPoste', id: 8 },
    { name: 'TNT', id: 9 },
    { name: 'TNT', id: 10 },
    { name: 'MNG', id: 11 },
    { name: 'EMS', id: 12 },
    { name: 'DPD', id: 13 },
    { name: 'Evri', id: 14 },
  ];
  b2bShipmentStatusList = [
    { name: 'Canceled', id: 0 },
    { name: 'Waiting Payment', id: 6 },
    { name: 'Ready To Shipment', id: 7 },
    { name: 'In Transit', id: 8 },
    { name: 'Shipped', id: 8 },
    { name: 'Delivered', id: 9 },
    { name: 'Label Failed', id: 98 },
  ];

  toggleDetailsOfShipment(index) {
    this.shipmentsListData[index].show_details =
      !this.shipmentsListData[index].show_details;
  }

  openShipmentReceipt(url) {
    window.open(url, '_blank', 'noopener');
  }
  openTrackingPage(trackingNumber) {
    window.open(trackingNumber, '_blank', 'noopener');
  }
  openLabelUrl(labelUrl) {
    window.open(labelUrl, '_blank', 'noopener');
  }

  openRefundDialog(shipmentId: string, trackingCode: string): void {
    const dialogRef = this.dialog.open(RefundShipmentDialogComponent, {
      data: { shipmentId, trackingCode },
      width: '500px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.handleRefundConfirmation(shipmentId);
      }
    });
  }

  private handleRefundConfirmation(shipmentId: string): void {
    this.signUpService.b2bRefundShipment(shipmentId, this.token).subscribe({
      next: (response) => {
        this.toastr.success('Shipment refunded successfully');

        this.shipmentsListData.forEach((shipment, index) => {
          if (shipment.id === shipmentId) {
            this.ngOnInit();
          }
        });
      },
      error: (error) => {
        this.toastr.error(error.error.message || 'Failed to refund shipment');
      },
    });
  }

  filterControlsContainer: boolean = false;
  filters = {
    company_id: 'all',
    status: 'all',
    pickup_status: 'all',
    date_range: 'none',
    custom_date_range: {
      start: 0,
      end: 0,
    },
    searchQuery: '',
    environment: ''
  };

  range = new UntypedFormGroup({
    start: new UntypedFormControl(Date),
    end: new UntypedFormControl(Date),
  });

  applyFilters(): void {
    if (this.filters.date_range === 'custom' && this.range.valid) {
      const start = this.range.get('start').value;
      const end = this.range.get('end').value;
      if (start && end) {
        this.filters.custom_date_range = {
          start: Math.floor(new Date(start).getTime() / 1000),
          end: Math.floor(new Date(end).getTime() / 1000),
        };
      }
    }
    this.currentPage = 1;
    this.shipmentsListData = [];
    this.hasMoreData = true;
    this.updateQueryParams();
    this.loadMoreShipments(true);
  }

  private resetAndReload(): void {
    this.currentPage = 1;
    this.shipmentsListData = [];
    this.hasMoreData = true;
    this.loadMoreShipments(true);
  }
  private prepareApiPayload(): any {
    const payload: any = {
      page: this.currentPage,
      page_size: this.pageSize,
    };

    if (this.filters.environment !== 'Environment') {
      payload.environment = this.filters.environment
    }

    if (this.filters.company_id !== 'all') {
      payload.company_id = Number(this.filters.company_id);
    }

    if (this.filters.status !== 'all') {
      payload.status = Number(this.filters.status);
    }

    if (this.filters.pickup_status !== 'all') {
      payload.pickup_status = Number(this.filters.pickup_status);
    }

    if (this.filters.searchQuery) {
      payload.searchKey = this.filters.searchQuery;
    }

    if (this.filters.date_range !== 'none') {
      switch (this.filters.date_range) {
        case 'today':
          const today = new Date();
          payload.date_range = "1"
          // payload.date_start = Math.floor(
          //   new Date(today.setHours(0, 0, 0, 0)).getTime() / 1000
          // );
          // payload.date_end = Math.floor(
          //   new Date(today.setHours(23, 59, 59, 999)).getTime() / 1000
          // );
          break;
        case 'last_7_days':
          payload.date_range = "2"
          // payload.date_start = Math.floor(
          //   new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).getTime() / 1000
          // );
          // payload.date_end = Math.floor(Date.now() / 1000);
          break;
        case 'last_30_days':
          payload.date_range = "3"
          // payload.date_start = Math.floor(
          //   new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).getTime() / 1000
          // );
          // payload.date_end = Math.floor(Date.now() / 1000);
          break;
        case 'custom':
          if (
            this.filters.custom_date_range.start &&
            this.filters.custom_date_range.end
          ) {
            payload.date_range = 'custom';
            payload.custom_date_range_start_date =
              this.filters.custom_date_range.start;
            payload.custom_date_range_end_date =
              this.filters.custom_date_range.end;
          }
          break;
      }
    }
    return payload;
  }

  private updateQueryParams(): void {
    const queryParams: any = {
      company_id:
        this.filters.company_id !== 'all'
          ? Number(this.filters.company_id)
          : null,
      status:
        this.filters.status !== 'all' ? Number(this.filters.status) : null,
      pickup_status:
        this.filters.pickup_status !== 'all'
          ? Number(this.filters.pickup_status)
          : null,
      date_range:
        this.filters.date_range !== 'none' ? this.filters.date_range : null,
      search: this.filters.searchQuery || null,
      page: this.currentPage,
      page_size: this.pageSize,
      environment: this.filters.environment !== 'Environment' ? this.filters.environment : null
    };

    if (this.filters.date_range === 'custom') {
      queryParams.date_start = this.filters.custom_date_range.start || null;
      queryParams.date_end = this.filters.custom_date_range.end || null;
    }

    Object.keys(queryParams).forEach(
      (key) => queryParams[key] === null && delete queryParams[key]
    );

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: '',
    });
  }

  searchWithEnter(event): void {

    if (this.filters.searchQuery.length > 0) {
      if (event.key === 'Enter') {
        let payload: any = {
          page: 1,
          page_size: 20,
        }
        payload.searchKey = this.filters.searchQuery;
        let queryParams: any = {
          page: 1,
          page_size: 20,
          search: this.filters.searchQuery,
        }

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams,
          queryParamsHandling: 'merge',
        });
      }
    } else {
      let queryParams: any = {
        page: 1,
        page_size: 20,
        search: null
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        queryParamsHandling: 'merge',
      });
    }



  }

  copyToClipboard(text: string, thing = ''): void {
    this.clipboard.copy(text);
    this.toastr.success(`${thing} copied to clipboard`, 'Success');
  }
}
